import store from '../store'

const handleError = (next) => {
  next('/auth/login')
}

export default async (to, from, next) => {
  await Promise.all([store.dispatch('user/getCurrentUser')])
  if (store.getters['user/error']) {
    handleError(next)
  } else {
    next()
  }
}
